import Immutable from 'seamless-immutable'

import * as actions from './actions'
import staticContent from './staticContent'

export const initialState = Immutable.from({
  fetching: false,
  error: false,
  footerItems: staticContent,
})

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.REQUEST_FOOTER:
      return state.set('fetching', true)
    case actions.RECEIVE_FOOTER:
      return state
        .set('fetching', false)
        .set('footerItems', payload)
        .set('loading', false)
        .set('error', false)
    case actions.ERROR_FETCHING_FOOTER:
      return state.set('error', true).set('fetching', false)
    default:
      return state
  }
}
